import { useRef } from 'react';
import { View } from 'react-native';

import { Pressable, PressableProps } from '../pressable';

import { useRadioItem } from './context';

export type RadioPressableProps = Omit<
  PressableProps,
  'role' | 'aria-checked' | 'aria-label' | 'onPress' | 'disabled'
>;

export function RadioPressable(props: RadioPressableProps) {
  const radioItem = useRadioItem();
  const pressableRef = useRef<View>(null);

  const accessibilityLabel = radioItem.disabled
    ? `${radioItem.label}. Unavailable`
    : radioItem.label;

  return (
    <Pressable
      ref={pressableRef}
      role="radio"
      aria-checked={radioItem.selected}
      disabled={radioItem.disabled}
      onPress={radioItem.handlePress}
      accessibilityLabel={accessibilityLabel}
      aria-label={accessibilityLabel}
      {...props}
    />
  );
}
